import { Currency } from "@redotech/money/currencies";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const constrainRateTableRelativeToOtherRateTable = {
  name: "constrainRateTableRelativeToOtherRateTable" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    rateTableId: zExt.objectId(),
    targetRateTableId: zExt.objectId(),
    constraintCurrency: createEnum(Currency),
  }),
  output: z.null(),
};
